import AudioFileOutlinedIcon from '@mui/icons-material/AudioFileOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import { Stack, useTheme } from '@mui/material';
import useAudioFileSize from 'services/hooks/audioFileSize/useAudioFileSize';
import { useAudioFileContext } from '../../context';
import {
  StyledContainer,
  StyledFileInfoWrapper,
  StyledFileName,
  StyledFileSize,
  StyledIconButton,
  StyledIconWrapper,
} from './styled';

type PropsType = {
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  onDeleteButtonClick: () => void;
};

const AudioFileInfoContainer = ({
  isLoading,
  isError,
  isSuccess,
  onDeleteButtonClick,
}: PropsType) => {
  const theme = useTheme();

  const { audioFile } = useAudioFileContext();
  const formattedFileSize = useAudioFileSize(audioFile?.size || null);

  return (
    <>
      <StyledContainer
        sx={{
          ...(isError && { border: `1px solid ${theme.palette.error.main}` }),
        }}
      >
        <StyledFileInfoWrapper>
          <StyledIconWrapper>
            <AudioFileOutlinedIcon />
          </StyledIconWrapper>
          <Stack alignItems="flex-start">
            <StyledFileName>{audioFile?.name}</StyledFileName>
            <StyledFileSize>{formattedFileSize}</StyledFileSize>
          </Stack>
        </StyledFileInfoWrapper>
        {!isLoading && !isSuccess && (
          <StyledIconButton onClick={onDeleteButtonClick}>
            <DeleteIcon />
          </StyledIconButton>
        )}
      </StyledContainer>
    </>
  );
};

export default AudioFileInfoContainer;
